import angular from "angular";
import $ from "jquery";

angular
    .module('ui-common')
    .directive("editLatLong", () => ({
        restrict: 'E',
        replace: false,
        scope: {
            reportsService: '=',
        },
        template: require('./edit-lat-long-directive.html'),
        controller: EditLatLongController,
        controllerAs: 'vm'
    }));

EditLatLongController.$inject = ['$scope', '$rootScope', 'ClientReportsService', 'FeedbackService', 'ApiErrorService'];

function EditLatLongController($scope, $rootScope, ClientReportsService, FeedbackService, ApiErrorService) {
    const vm = this;
    vm.uid = $scope.$id;

    vm.changeLatLongBegin = (report) => {
        vm.changeLatLongErrorMessage = null;
        vm.newLatitude = report.latitude;
        vm.newLongitude = report.longitude;
        vm.originalLatitude = report.latitude;
        vm.originalLongitude = report.longitude;
        FeedbackService.clear();
        document.getElementById('txt-newLatitude-' + vm.uid).focus();
    };

    vm.changeLatLongCancel = () => {
        vm.changeLatLongErrorMessage = null;
        vm.newLatitude = null;
        vm.newLongitude = null;
        vm.originalLatitude = null;
        vm.originalLongitude = null;
        FeedbackService.clear();
    };

    vm.changeLatLongSubmit = () => {
        const reportService = $scope.reportsService;
        const report = reportService.selected;

        FeedbackService.clear();
        if (vm.newLatitude === null || vm.newLatitude === undefined || String(vm.newLatitude).trim() === '' || isNaN(vm.newLatitude)) {
            FeedbackService.addError('Latitude is not valid.');
            return;
        }
        if (vm.newLongitude === null || vm.newLongitude === undefined || String(vm.newLongitude).trim() === '' || isNaN(vm.newLongitude)) {
            FeedbackService.addError('Longitude is not valid.');
            return;
        }
        const sentryStatusId = report.sentryStatusId || report.reportGuid;
        if (!sentryStatusId) {
            FeedbackService.addError('Report does not have a SentryStatusId or ReportGuid.');
            return;
        }
        $rootScope.loading = true;
        const promise = ClientReportsService.changeLatLongForReport(sentryStatusId, vm.newLatitude, vm.newLongitude).$promise;
        promise.then(
            function (updateList) {
                $('#editLatLongModal-' + vm.uid).modal('hide');
                vm.changeLatLongErrorMessage = null;
                vm.newLatitude = null;
                vm.newLongitude = null;
                for (const sentryStatus of updateList) {
                    if (reportService.selected.sentryStatusId === sentryStatus.id) {
                        reportService.selected.latitude = sentryStatus.latitude;
                        reportService.selected.longitude = sentryStatus.longitude;
                        reportService.selected.locationMethod = sentryStatus.locationMethod;
                    }
                    const report = reportService.reports.find(r => r.sentryStatusId === sentryStatus.id);
                    if (report) {
                        report.latitude = sentryStatus.latitude;
                        report.longitude = sentryStatus.longitude;
                        report.locationMethod = sentryStatus.locationMethod;
                    }
                }
            },
            function (error) {
                const message = ApiErrorService.getMessage(error, 'An unknown error occurred while updating the location.');
                FeedbackService.addError(message);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    };
}
